export default __webpack_public_path__ + "static/media/mq-new-7.29b0b668.jpg";